export default {
	title: "Orixás",
	name: "Name",
	color: "Color",
	create: "New Orixá",
	edit: "Edit Orixá",
	confirmDeleteMessage: "Are you sure you want to delete the orixá {name}? Linked persons will have the field cleared.",
	searchPlaceholder: "Search orixá...",
	noData: "No orixás registered",
	stats: {
		total: "Total",
	},
	messages: {
		createSuccess: "Orixá created successfully",
		updateSuccess: "Orixá updated successfully",
		deleteSuccess: "Orixá deleted successfully",
		createError: "Error creating orixá",
		updateError: "Error updating orixá",
		deleteError: "Error deleting orixá",
		loadError: "Error loading orixás",
	},
	validation: {
		nameRequired: "Name is required",
		nameMaxLength: "Name must be at most 100 characters",
	},
};
